<template>
  <div id="versionNumber">
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      @search="getTableData"
    ></ots-table-group-new>
  </div>
</template>
<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { versionQueryListAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        } 
      ],
      requestForm: {
        planId: '',
      },
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "数据包版本号",
          prop: "versionCode",
        },
        {
          title: "生成时间",
          prop: "createTime",
        }
      ],
      tableData: [],
    }
  },
  methods: {
    async initData() {
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },
    async getTableData() {
      let params = { ...this.requestForm };
      const { data, code } = await versionQueryListAPI(params);
      if (code == 1) {
        this.tableData = data;
      }
    },
  },
  mounted() {
    this.initData();
  },
  watch: {
    "requestForm.planId": function() {
      this.getTableData();
    }
  }
}
</script>